import { UserException } from '@/domain/user/exception/UserException'

export class EmailTakenByInactiveUserException extends UserException {

}
